import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  BasketItemPaymentOption,
  CoverPaymentOptions,
  PaymentType,
} from '@common/util-models';
import { RadioListItemValue } from '@domgen/dgx-fe-components-core';
import { Payment } from '../payment-card/payment-card.component';

const titleMap = {
  [PaymentType.DirectDebit]: 'Direct Debit',
  [PaymentType.Card]: 'Credit or debit card',
};

@Component({
  selector: 'wl-payment-method-selection',
  templateUrl: './payment-method-selection.component.html',
  styleUrls: ['./payment-method-selection.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: PaymentMethodSelectionComponent,
    },
  ],
})
export class PaymentMethodSelectionComponent
  implements ControlValueAccessor, OnChanges
{
  @Input() selected: RadioListItemValue = null;
  @Input() availablePaymentMethod?: CoverPaymentOptions | null;
  @Output()
  paymentMethodChange: EventEmitter<RadioListItemValue> = new EventEmitter();
  productOptionArray: Payment[] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.availablePaymentMethod) {
      if (this.availablePaymentMethod) {
        this.mapToPaymentCardObject(this.availablePaymentMethod);
      }
    }
  }

  onTouched: () => void = () => {
    return undefined;
  };

  onChanged: (val: unknown) => void = () => {
    return undefined;
  };

  onSelectionChange(val: RadioListItemValue) {
    if (this.selected !== val) {
      this.onChanged(val);
    }
    this.selected = val;
  }

  registerOnChange(fn: (val: unknown) => void) {
    this.onChanged = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  writeValue(val: RadioListItemValue) {
    if (this.selected !== val) {
      this.paymentMethodChange.emit(val);
    }
    this.selected = val;
  }

  mapToPaymentCardObject(productOption: CoverPaymentOptions) {
    const productOptionArray = Object.values(productOption);
    this.selected = productOptionArray.find(
      (paymentOption?: BasketItemPaymentOption) =>
        paymentOption?.preferredPayment
    )?.paymentType;

    this.productOptionArray = productOptionArray
      .filter(Boolean)
      .map((option: BasketItemPaymentOption) => ({
        directDebitDiscount: option?.directDebitDiscount,
        discount: option.discount,
        discountPeriod: option.discountPeriod,
        firstDiscountPayment: option.firstDiscountPayment,
        firstMonthPayment: option.firstPayment,
        id: option.paymentType,
        numPayments: option.numPayments,
        numSubsequentPayments: option.numSubsequentPayments,
        paymentType: option.paymentType,
        perMonthPrice: option.subsequentPayment,
        preferredPayment: option.preferredPayment,
        subsequentDiscountPayment: option.subsequentDiscountPayment,
        totalOfDiscount: option.totalOfDiscount,
        totalPrice: option.fee,
        title: titleMap[option.paymentType],
      }))
      //Direct Debit first
      .sort(({ paymentType: a }, { paymentType: b }) => {
        if (a === b) {
          return 0;
        }
        if (a === PaymentType.DirectDebit) {
          return -1;
        }
        return 1;
      });
  }
}
